import styles from "./UpdatePaymentModal.module.scss";
import close from "../../../assets/icons/close.svg";
import payPal from "../../../assets/icons/pay-pal.svg";
import { useTranslation } from "react-i18next";
import { subscriptionData } from "../../../types/details-api-types";
import { useEffect } from "react";
import { trackEvent } from "../../../utils/analytics";
import { EVENT_NAMES } from "../../../types/event-names";

interface UpdatePaymentModalProps {
  setIsModalUpdatePayVisible: (arg: boolean) => void;
  setIsModalCardInfoVisible: (arg: boolean) => void;
  setIsUpdatePayPalVisible: (arg: boolean) => void;
  setIsModalUpdatePaySuccessfullyVisible: (arg: boolean) => void;
  subscriptionItem?: subscriptionData | null;
}

const UpdatePaymentModal: React.FC<UpdatePaymentModalProps> = ({
  setIsModalUpdatePayVisible,
  setIsModalCardInfoVisible,
  setIsUpdatePayPalVisible,
  setIsModalUpdatePaySuccessfullyVisible,
  subscriptionItem,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    trackEvent(EVENT_NAMES.PAYMENT_METHOD_CLICKED);
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <p className={styles.root_header_title}>{t("Update Your Payment Method")}</p>
        <img
          src={close}
          alt="close"
          onClick={() => setIsModalUpdatePayVisible(false)}
          className={styles.root_header_img}
        />
      </div>
      <p className={styles.root_subtitle}>{t("Choose a new payment method for your Fortect subscription")}</p>

      <div className={styles.root_footer}>
        <button
          className={styles.root_footer_credit}
          onClick={() => {
            setIsModalUpdatePayVisible(false);
            // setIsModalCardInfoVisible(true);
            trackEvent(EVENT_NAMES.PAYMENT_METHOD_CHOSE_METHOD, {
              paymentMethod: "Credit Card",
              parameter: "CC",
            });

            trackEvent(EVENT_NAMES.PAYMENT_METHOD_PROCESSOR_OPENED, {
              paymentMethod: "Credit Card",
              parameter: "CC",
            });

            window.open(subscriptionItem?.customerURL, "_blank");
          }}
        >
          {t("Credit Card")}
        </button>
        <button
          className={styles.root_footer_payPal}
          onClick={() => {
            setIsModalUpdatePayVisible(false);
            // showProcessingModal();
            trackEvent(EVENT_NAMES.PAYMENT_METHOD_CHOSE_METHOD, {
              paymentMethod: "PayPal",
              parameter: "PP",
            });

            trackEvent(EVENT_NAMES.PAYMENT_METHOD_PROCESSOR_OPENED, {
              paymentMethod: "PayPal",
              parameter: "PP",
            });

            window.open(subscriptionItem?.customerURL, "_blank");
          }}
        >
          <img src={payPal} alt="payPal" />
        </button>
      </div>
    </div>
  );
};

export default UpdatePaymentModal;
